'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var newStyle = {};
    var props = Object.keys(style).sort(sort);

    for (var i = 0; i < props.length; i++) {
      newStyle[props[i]] = style[props[i]];
    }

    return newStyle;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

exports.default = jssPropsSort;



//////////////////
// WEBPACK FOOTER
// ./~/jss-plugin-props-sort/dist/jss-plugin-props-sort.cjs.js
// module id = 399
// module chunks = 0